import { useSelector } from "react-redux"



const SidebarIconSvg = () => {

    const {theme} = useSelector(state => state.layout)

  return (
    <svg width="121" height="82" viewBox="0 0 121 82" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="120" height="81" rx="5.5"  fill={theme === "dark" ? "#333" : "#fff"} stroke={theme === "dark" ? "#444" : "#EEEEEE"}/>
<path d="M0 6C0 2.68629 2.68629 0 6 0H10V82H6C2.68629 82 0 79.3137 0 76V6Z" fill={theme === "dark" ? "#444" : "#ECECEC"}/>
<rect x="4" y="14" width="2" height="6" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="22" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="26" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="30" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="34" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="38" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="42" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="46" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="50" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="54" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="58" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
<rect x="4" y="62" width="2" height="2" rx="1" fill={theme === "dark" ? "#333333" : "#CECECE"}/>
</svg>

  )
}

export default SidebarIconSvg